import { RcClasses } from '../../../foundation';
export var RcPopoverClasses = RcClasses([], 'RcPopover');
